import { useState, useEffect } from "react";
import Highlighter, { hasKeywordHighlight } from './Highlighter';

const Expandable = ({ text, keyword }) => {
  const [expanded, setExpanded] = useState(() => hasKeywordHighlight(text, keyword));

  useEffect(() => {
    setExpanded(hasKeywordHighlight(text, keyword));
  }, [text, keyword]);

  return (
    <div>
      <p className={`${expanded ? "" : "line-clamp-1"}`}>
        {<Highlighter text={text} keyword={keyword} />}
      </p>

      <button
        className="text-primary font-medium bg-transparent mt-1 hover:underline"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? "Show less" : "Show more"}
      </button>
    </div>
  );
};

export default Expandable;